import { useQuery } from '@tanstack/react-query'
import { healthApi } from '../../rest/modules/health-api'

export const healthKeys = {
  all: ['health'] as const,
  status: () => [...healthKeys.all, 'status'] as const,
}

export const useHealthStatus = () => {
  return useQuery({
    queryKey: healthKeys.status(),
    queryFn: () => healthApi.getStatus(),
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 5,
  })
}
